// extracted by mini-css-extract-plugin
export var link = "tinyTitle-module--link--18nXT";
export var visible = "tinyTitle-module--visible--g-Iot";